import {IRegulationPresetValues} from '../regulation-preset-values.interface';

export const GERMANY_PRESETS_VALUES: IRegulationPresetValues = {
    sdk: {
        Skin: {
            regulationID: 12,
            brandID: 84,
            subBrandID: 137
        },
        Currency: {
            anonymousCurrency: 'EUR'
        },
        OAuth2: {
            fakeClientIP: '2.16.6.0'
        }
    },
    orbit: {
        country: 'deu',
        language: 'ger',
        iso2: 'de',
        publicationID: 1991,
        cmsSource: 'https://slots.888wetten.de'
    }
}